import { useNavigate } from "react-router-dom";

import Button from "../../../../components/Buttons/Button";
import { formatDateMDKorean } from "../../../../utils";
import CustomModal from "../../../../components/Modal/CustomModal";
const CheckListedLostItem = ({ list, isOpen, onRequestClose }) => {
  const navigate = useNavigate();

  const onClose = () => {
    navigate(-1);
  };

  return (
    <CustomModal
      btnClose
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="분실물 접수 내역 안내"
      onClose={onClose}
    >
      <h3 className="mb-5 text-2xl font-semibold text-center break-keep">
        등록된 분실물 접수 내역이 있습니다. <br /> 확인 부탁드립니다.
      </h3>

      <ul className="flex flex-col gap-2 overflow-y-auto max-h-48 mb-7">
        {list?.map((item, index) => (
          <li key={index} className="text-base text-center">
            <p>
              접수일자 :{" "}
              <b className="text-lg font-semibold">
                {formatDateMDKorean(item.register_date)}
              </b>
            </p>
            <p>
              분실일자 :{" "}
              <b className="text-lg font-semibold">
                {formatDateMDKorean(item.lose_date)}
              </b>
            </p>
            <p>
              접수번호 :{" "}
              <b className="text-lg font-semibold">{item.acpn_number}</b>
            </p>
            <p>
              접수물품 :{" "}
              <b className="text-lg font-semibold">{item.description}</b>
            </p>
          </li>
        ))}
      </ul>

      <Button
        onClick={() => {
          navigate("/lost?agree=true", { replace: true });
          onRequestClose();
        }}
        size="sm"
      >
        추가등록
      </Button>
    </CustomModal>
  );
};

export default CheckListedLostItem;
